/**
 * BigQuery event groups.
 */
export enum BigQueryEventGroup {
    /**
     * User action.
     */
    Action = 'user_action',
    /**
     * User impression.
     */
    Impressions = 'user_impressions',
}

/**
 * BigQuery event base options.
 */
export const BIG_QUERY_EVENT_BASE_OPTIONS = {
    sub_group: 'certified_event',
    feature: {
        name: 'fiverr_certified',
    },
} as const;
